import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { Nullable } from '~globals/types';
import { CollectItemStateTypes } from '~globals/types/enums';

interface OrderReceivedStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
  tooltipMessage: string;
}

type OrderReceivedStateList = {
  [state in CollectItemStateTypes]: OrderReceivedStateInfoItem;
};

export const useOrderReceivedStateInfo = (
  collectItemStateTypeId: Nullable<CollectItemStateTypes>,
): OrderReceivedStateInfoItem => {
  const stateList = useMemo<OrderReceivedStateList>(
    () => ({
      [CollectItemStateTypes.ToValidate]: {
        description: 'Sin colecta',
        color: 'secondary',
        tooltipMessage: 'El dador la llevara a la base del transportista',
      },
      [CollectItemStateTypes.ToCollect]: {
        description: 'A colectar',
        color: 'secondary',
        tooltipMessage:
          'Lista para que el transportista la retire en el punto de venta.',
      },
      [CollectItemStateTypes.InCollect]: {
        description: 'En colecta',
        color: 'primary',
        tooltipMessage: 'En colecta tooltip.',
      },
      [CollectItemStateTypes.Validated]: {
        description: 'Colectado',
        color: 'success',
        tooltipMessage: 'El transportista ya la tiene en su poder.',
      },
      [CollectItemStateTypes.NotValidated]: {
        description: 'No colectado',
        color: 'error',
        tooltipMessage: 'No colectado tooltip.',
      },
      [CollectItemStateTypes.InWarehouse]: {
        description: 'Recepcionado',
        color: 'quaternary',
        tooltipMessage: 'Ingresada al depósito del transportista.',
      },
    }),
    [],
  );

  const currentInfo = useMemo<OrderReceivedStateInfoItem>(
    () =>
      get(
        stateList,
        collectItemStateTypeId ?? CollectItemStateTypes.ToValidate,
      ),
    [stateList, collectItemStateTypeId],
  );

  return currentInfo;
};
